"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = require("react");
var _1 = require(".");
function useNotifications() {
    var context = react_1.useContext(_1.LayoutNotificationContext);
    if (!context) {
        throw Error('The `useNotifications` hook must be called from a descendent of the `LayoutNotificationArea`.');
    }
    return {
        addNotification: context.addNotification,
        removeNotification: context.removeNotification,
        removeAllNotifications: context.removeAllNotifications
    };
}
exports.useNotifications = useNotifications;
//# sourceMappingURL=useNotifications.js.map